import { action, observable, makeObservable } from 'mobx';

export interface IIntegration {
    id?: string;
    name?: string;
    data: {
        exportProcesses?: boolean;
        exportModules?: boolean;
        exportDrivers?: boolean;
        exportArtifacts?: boolean;
        exportAutoStarts?: boolean;
        exportMemScans?: boolean;
        server?: string;
        port?: string;
        token?: string;
    };
    enabled?: boolean;
    showCollectorToken?: boolean;
}

export default class IntegrationStore {
    integration = {};

    constructor(integration: IIntegration) {
        makeObservable(this, {
            integration: observable,
            update: action
        });

        this.update(integration);
    }

    update(integration: IIntegration): void {
        this.integration = {
            ...this.integration,
            ...integration
        };
    }
}
